import { CircleStackIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { formatDateTime } from '../../utils/calcs'
import { getNextStep, nextStepLabels } from '../../utils/nextStep'

function ProjectCard({ project, ...rest }) {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const nextStep = getNextStep(project)
    const NextStepIcon = nextStep?.icon
    const labels = nextStepLabels(t, nextStep)
    return (
        <div data-testid={`project-card-${project.uuid}`} {...rest}>
            <div className='flex flex-col shadow-2xl px-4 py-4 w-full bg-white rounded-2xl h-full '>
                <div className='flex justify-between flex-col sm:flex-row'>
                    <div className='flex items-center justify-start mb-4 ml-1'>
                        <CircleStackIcon className='w-9 h-9' />
                        <div className=' pl-4'>
                            <div className='text-base font-semibold  text-gray-900'>
                                {project.name}
                            </div>
                            <div className='text-xs text-gray-500'>
                                {t('Projects.Created')} {formatDateTime(project.created_at)} · {t('Projects.Updated')} {formatDateTime(project.updated_at)}
                            </div>

                        </div>

                    </div>
                    <div className='flex h-fit gap-2'>
                        <button
                            className='border border-black bg-black text-white rounded-lg px-4 py-1.5 text-sm mb-2 w-full'
                            onClick={() => { navigate("/project/" + project.uuid) }}
                            data-testid="project-card-view-button"
                        >{t('Projects.View')}</button>
                    </div>

                </div>
                <div className='px-2 text-sm py-4 border-t-2 border-dotted h-full'>
                    {project.description}
                </div>
                {nextStep && (
                    <div
                        className='flex items-center gap-3 rounded-xl border border-dashed border-gray-300 px-4 py-3'
                        data-testid="project-card-next-step"
                    >
                        <NextStepIcon className='h-6 w-6 shrink-0 text-gray-900' />
                        <div className='min-w-0'>
                            <div className='text-xs uppercase tracking-wide text-gray-500'>
                                {t('Dashboard.NextStepLabel')}
                            </div>
                            <div className='text-sm font-semibold text-gray-900'>
                                {labels.title}
                            </div>
                            <div className='text-sm text-gray-500'>
                                {labels.description}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProjectCard
